module.exports = __webpack_public_path__ + "static/media/olivia-wilde-win.aa47bcb5.jpg";